import { Global, css } from "@emotion/react";

import { stylesReset } from "./styles";
import { GlobalResetProps } from "./types";

export const GlobalReset = ({
  styles = "",
  spaces = {
    xs: 5,
    sm: 15,
    md: 30,
    lg: 45,
    xl: 75,
  },
  borderRadius = {
    xs: 2,
    sm: 5,
    md: 10,
    lg: 20,
    xl: 50,
  },
  breakpoints = {
    xs: 356,
    sm: 576,
    md: 768,
    lg: 1050,
    xl: 1400,
  },
  fontSizes = {
    indicator: 60,
    title: 34,
    subtitle: 28,
    header: 22,
    text: 16,
    note: 12,
  },
}: GlobalResetProps) => {
  return (
    <Global
      styles={css`
        ${stylesReset}

        :root {
          // spaces
          --space-xs: ${spaces.xs / 16}rem;
          --space-sm: ${spaces.sm / 16}rem;
          --space-md: ${spaces.md / 16}rem;
          --space-lg: ${spaces.lg / 16}rem;
          --space-xl: ${spaces.xl / 16}rem;

          // font-sizes
          --font-size-indicator: ${fontSizes.indicator / 16}rem;
          --font-size-title: ${fontSizes.title / 16}rem;
          --font-size-subtitle: ${fontSizes.subtitle / 16}rem;
          --font-size-header: ${fontSizes.header / 16}rem;
          --font-size-text: ${fontSizes.text / 16}rem;
          --font-size-note: ${fontSizes.note / 16}rem;

          // border-radius
          --border-radius-xs: ${borderRadius.xs / 16}rem;
          --border-radius-sm: ${borderRadius.sm / 16}rem;
          --border-radius-md: ${borderRadius.md / 16}rem;
          --border-radius-lg: ${borderRadius.lg / 16}rem;
          --border-radius-xl: ${borderRadius.xl / 16}rem;

          // breakpoints
          --breakpoints-xs: ${breakpoints.xs / 16}rem;
          --breakpoints-sm: ${breakpoints.sm / 16}rem;
          --breakpoints-md: ${breakpoints.md / 16}rem;
          --breakpoints-lg: ${breakpoints.lg / 16}rem;
          --breakpoints-xl: ${breakpoints.xl / 16}rem;

          // breakpoints-px
          --breakpoints-px-xs: ${breakpoints.xs}px;
          --breakpoints-px-sm: ${breakpoints.sm}px;
          --breakpoints-px-md: ${breakpoints.md}px;
          --breakpoints-px-lg: ${breakpoints.lg}px;
          --breakpoints-px-xl: ${breakpoints.xl}px;
        }

        ${styles}
      `}
    />
  );
};
